import { makeStyles, Text } from '@rneui/themed'
import { durationString } from '@nextforce/api'
import React from 'react'

interface Props {
  hours?: number
  textStyle?: any
  isInterested?: boolean
}

export function ShiftTotalHoursView(props: Props) {
  const styles = useStyles()

  if (props.isInterested && props.hours === undefined) {
    return null
  }

  if (!props.hours) {
    return null
  }

  return (
    <Text style={[styles.container, props.textStyle]}>{`Week: ${durationString(
      props.hours
    )}`}</Text>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    fontSize: 13,
    color: theme.colors?.grey2,
  },
}))
